import React from 'react'
import { ConfigProvider } from "antd";

import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import utils from '@/utils'
import 'animate.css'
import './style/base.css'
import './style/App.css'
import ProtectedRoute from './components/ProtectedRoute';
import locale from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';
import dayjs from 'dayjs';
dayjs.locale('zh-cn');

const { loadable } = utils;

// 基础页面
const View404 = loadable(() => import(/* webpackChunkName: '404' */ './views/Others/404'))
const View500 = loadable(() => import(/* webpackChunkName: '500' */ './views/Others/500'))
const Login = loadable(() => import(/* webpackChunkName: 'login' */ './views/Login'))

const App = () => (
    <ConfigProvider locale={locale}>
        <Router>
            <Routes>
                <Route path='/' element={<Navigate to='/index' replace />} />
                <Route path='/500' element={<View500 />} />
                <Route path='/login' element={<Login />} />
                <Route path='/404' element={<View404 />} />
                {/* <Route component={DefaultLayout} /> */}

                {/* 保护 DefaultLayout 下的所有路由 */}
                <Route path='/*' element={<ProtectedRoute />} />
            </Routes>
        </Router>
    </ConfigProvider>
)

export default App
